<template>
  <div>
    <nav-bar :title="`${childSelectedName}´s Coins`" />
    <div class="mobile pt-4">
      <b-container>
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <coins-updater-skeleton />
          </template>
          <coins-updater-form :coinsValues="CoinsValues" @updateCoinsValues="updateCoinsValues" />
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { getChildCoinsValues, updateCoinstValues } from '@/gamification/services';
import { NavBar } from '@/common/components';
import CoinsUpdaterSkeleton from '@/gamification/components/skeletons/CoinsUpdaterSkeleton';
import CoinsUpdaterForm from '@/gamification/components/CoinsUpdaterForm';

export default {
  components: {
    NavBar,
    CoinsUpdaterSkeleton,
    CoinsUpdaterForm,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      CoinsValues: [],
      loading: false,
    };
  },
  computed: {
    childSelectedName() {
      return this.sessionStore.childName;
    },
    getChildId() {
      return this.sessionStore.childSelectedId;
    },
  },
  methods: {
    async getCoinsValues() {
      this.loading = true;
      const childId = this.getChildId;
      try {
        this.CoinsValues = await getChildCoinsValues({ childId });
      } catch (error) {
        throw new Error(error);
      } finally {
        this.loading = false;
      }
    },

    async updateCoinsValues({ coinsToUpdate }) {
      const childId = this.getChildId;
      await updateCoinstValues({ childId, coinsToUpdate });
      this.getCoinsValues();
    },
  },
  mounted() {
    this.getCoinsValues();
  },
};
</script>

